import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=bee33b38&scoped=true&"
import script from "./InputDate.vue?vue&type=script&lang=js&"
export * from "./InputDate.vue?vue&type=script&lang=js&"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=bee33b38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee33b38",
  null
  
)

export default component.exports